import { hsmBackendClient } from './client';
import { IControllerResponse } from './types';

export interface DeriveWabaResult {
  websiteId: string;
  wabaId: string;
  /** `false` cuando el Website ya tenía wabaId (idempotente, no re-derivó). */
  derived: boolean;
}

/**
 * Deriva y persiste el `wabaId` de una línea Meta-coexistence con onboarding
 * parcial (el `Website` tiene `fbPageAccessToken` + `externalId` pero `wabaId`
 * vacío). Hits `POST /website/{websiteId}/hsm/derive-waba` (hsm-backend proxea a
 * Kori, que deriva el wabaId vía debug_token y lo persiste). Reemplaza el
 * "completá la config en Kori a mano" del alta. roadmap#1263.
 *
 * Errores propagan: `422` cuando no es derivable (faltan token/externalId, o
 * ninguna WABA es dueña del número) → el caller cae al mensaje manual.
 */
export async function deriveWaba(websiteId: string): Promise<DeriveWabaResult> {
  const response = await hsmBackendClient.post<
    IControllerResponse<DeriveWabaResult>
  >(`/website/${encodeURIComponent(websiteId)}/hsm/derive-waba`, {});

  if (!response.data.result) {
    throw new Error(
      response.data.message ?? 'Respuesta del backend sin result'
    );
  }
  return response.data.result;
}
